import type { MessageKey } from "../types";

/** English UI copy — one entry per key in ru.ts. */
export const enOverrides: Partial<Record<MessageKey, string>> = {
  "nav.rating": "VPN rating",
  "nav.protocol": "Rating protocol",
  "hero.rating": "VPN rating",
  "hero.criteria": "Rating criteria",
  "hero.title": "Zvezda NA SVYAZI",
  "hero.intro":
    '<div class="font-semibold max-w-[920px] md:text-c2rem xs:text-xl pb-3 md:leading-10">Our experts went through hundreds of your questions and checked every service against the strictest safety criteria.</div><div class="font-semibold max-w-[920px] md:text-c2rem xs:text-xl md:leading-10">Only tools that meet every requirement receive the NA SVYAZI star.\u00a0</div>',
  "nav.contacts": "Contact",
  "search.placeholder": "Enter VPN service name",
  "main.learnMore": "Learn more",
  "main.viewRating": "View rating",
  "region.label": "Region:",
  "lang.name.ru": "Russian",
  "lang.name.en": "English",
  "lang.name.az": "Azerbaijani",
  "lang.modalTitle": "Language",
  "rating.notFoundTitle": 'Nothing found for "{{query}}".',
  "rating.notFoundHint":
    "Check the service name and try again, or we may not have reviewed this service yet...",
  "rating.missingService": "Can't find your service?",
  "vpn.ruBadge": "Works in Russia",
  "vpn.hide": "Hide",
  "vpn.more": "Details",
  "vpn.goToService": "Go to service",
  "vpn.promoOnButton": "already on the button",
  "vpn.altLink": "Alternative link",
  "vpn.field.starVerified": "Verified by Zvezda NA SVYAZI",
  "vpn.field.jurisdiction": "Jurisdiction",
  "vpn.field.zeroTracking": "No log / Zero tracking policy",
  "vpn.field.obfuscation": "Obfuscation (traffic masking)",
  "vpn.field.cryptoPayment": "Anonymous payment (crypto)",
  "vpn.field.personalData": "Requires personal data at registration",
  "vpn.field.support": "Support",
  "vpn.field.altClients": "Alternative clients",
  "vpn.field.splitTunneling": "Split tunneling",
  "vpn.field.protocols": "Supported protocols",
  "common.yes": "Yes",
  "common.no": "No",
  "common.free": "Free",
  "common.present": "Yes",
  "common.absent": "No",
  "common.altClientsAbsent": "None",
};
